import { render, staticRenderFns } from "./ResultadosPorDia.vue?vue&type=template&id=a90d2bde&"
import script from "./ResultadosPorDia.vue?vue&type=script&lang=js&"
export * from "./ResultadosPorDia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports